export const WITH_PRODUCTS_PENDING_ACTIVATION =
  'Selecione abaixo o serviço que deseja ativar ou acesse pela Tela Inicial.'

export const WITHOUT_PRODUCTS_PENDING_ACTIVATION = (
  <>
    <strong>Estamos finalizando sua assinatura.</strong> Em até <strong>5 minutos</strong>, seus
    serviços estarão disponíveis na <strong>Tela Inicial</strong> para ativação.
  </>
)
